import { AppControllerType } from '@/common/interfaces';

import NotFoundCommonPage from '@/pages/NotFound/NotFoundCommon.page';
import NotFoundDrawerPage from '@/pages/NotFound/NotFoundDrawer.page';

import { DomainsApiController } from './DomainsApi/domainsApi.controller';
import { SitesController } from './Sites/sites.controller';
import { DnsRecordsController } from './dnsRecords.controller';
import { DomainRegistrarsController } from './domainRegistrars.controller';
import { DomainsController } from './domains.controller';
import { HostingsController } from './hostings.controller';
import { PagesController } from './pages.controller';
import { ProxyServersController } from './proxyServers.controller';
import { SiteGroupsController } from './siteGroups.controller';

export const AppController: AppControllerType = {
  common: [
    {
      element: 'home',
      breadcrumb: null,
      index: true
    },
    ...SitesController.common,
    ...SiteGroupsController.common,
    ...PagesController.common,
    ...DnsRecordsController.common,
    ...DomainRegistrarsController.common,
    ...DomainsController.common,
    ...DomainsApiController.common,
    ...HostingsController.common,
    ...ProxyServersController.common,
    {
      path: '*',
      breadcrumb: null,
      element: <NotFoundCommonPage/>
    }
  ],
  drawer: [
    ...SitesController.drawer,
    ...SiteGroupsController.drawer,
    ...PagesController.drawer,
    ...DnsRecordsController.drawer,
    ...DomainRegistrarsController.drawer,
    ...DomainsController.drawer,
    ...DomainsApiController.drawer,
    ...HostingsController.drawer,
    ...ProxyServersController.drawer,
    {
      path: '*',
      breadcrumb: null,
      element: <NotFoundDrawerPage/>
    }
  ]
};
